import {createSlot} from '../../utils/react';

export const [
  DashboardPanelActionsSlotProvider,
  DashboardPanelActionsSlotArea,
  DashboardPanelActionsSlot,
] = createSlot();
